import { Col, Row, Slider } from '@microfrontends/react-components'
import { useContext, useEffect, useState } from 'react'
import { EDevice } from '../../containers/MainLayout'
import AppContext from '../../context/AppContext'
import NumerologyApi from '../../services/numerology'
import {
	EPageTypeFamousPeople,
	IFamousPeople
} from '../../services/numerology/@type'
import WindowBox from './WindowBox'

interface IProps {
	rulingNumber?: string | number
	pageType?: EPageTypeFamousPeople
	isRobot?: boolean
	ssrFamousPeople?: IFamousPeople[]
}
export default function SlideFamosPeople({
	rulingNumber,
	pageType,
	isRobot,
	ssrFamousPeople
}: IProps) {
	const { breakpoint } = useContext(AppContext)
	const [famousPeople, setFamousPeople] = useState<IFamousPeople[] | null>(
		ssrFamousPeople || null
	)
	const [loading, setLoading] = useState(true)
	const getFamousPeople = async () => {
		try {
			const data = await NumerologyApi.getFamousPeople(
				pageType,
				Number(rulingNumber)
			)
			setLoading(false)
			if (data) {
				setFamousPeople(data)
				return
			}
			setLoading(true)
		} catch (error) {
			console.error(error)
		}
	}
	useEffect(() => {
		switch (pageType) {
			case EPageTypeFamousPeople.HomePage:
				getFamousPeople()
				break
			default:
				if (rulingNumber) {
					getFamousPeople()
				}
				break
		}
	}, [rulingNumber])

	const elmPerViewByDevice = (
		famousPeople: IFamousPeople[] | null
	): number => {
		if (!famousPeople || famousPeople.length < 1) return 0
		switch (breakpoint) {
			case EDevice.MOBILE:
				return 1
			case EDevice.TABLET:
				return 3
			default:
				return famousPeople?.length >= 4 ? 4 : famousPeople.length
		}
	}

	return (
		<Row>
			<Col>
				<Slider
					id='Slider-test-1'
					loadingEnable={loading}
					slides={{
						elementPerView: elmPerViewByDevice(famousPeople)
					}}
					autoEnable={
						famousPeople &&
						famousPeople.length > elmPerViewByDevice(famousPeople)
							? true
							: false
					}
					isRobot={isRobot}
					autoTime={5000}
					pagination={{
						maxShow: 4,
						type:
							famousPeople &&
							famousPeople.length >
								elmPerViewByDevice(famousPeople)
								? 'default'
								: 'none'
					}}
					container={{ style: { width: '100%' } }}
				>
					{famousPeople && famousPeople.length > 0
						? famousPeople.map((elm, index) => {
								const item = {
									content: elm.rulingNumber ?? '',
									image: elm.images ?? '',
									info: {
										title: elm.fullName ?? '',
										subTitle: elm.title ?? '',
										date: elm.birthday ?? ''
									}
								}
								return (
									<WindowBox
										key={index}
										item={item}
										type='human'
										style={{
											padding: '20px 0',
											margin: '0 auto'
										}}
									/>
								)
						  })
						: null}
				</Slider>
			</Col>
		</Row>
	)
}
